// react-bootstrap
import { Form } from "react-bootstrap";

// Hooks
import { useState } from "react";
import Alertas from "../../common/Alertas";

// Styles
import styled from "styled-components";

// dropzone
import { useDropzone } from "react-dropzone";

// variables entorno
import { URL_IMAGE_GEOMEDELLIN } from "../../../environment";

const Dropzone = styled.div`
  cursor: pointer;
  border-radius: 15px;
  color: #2e2e2e;
  background-color: #ececec;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  height: 110px;
  img {
    width: 95%;
    height: 90%;
    object-fit: cover;
    object-position: 50% 50%;
    border-radius: 15px;
  }
  video {
    width: 95%;
    height: 100%;
    object-fit: cover;
    object-position: 50% 50%;
    border-radius: 15px;
  }
  .container-picture {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .description-picture {
    font-size: 12px;
  }
`;

export const DropZoneFile = ({
  extensiones,
  tipoFile,
  config,
  onNewFile,
  rutaEdit = null,
  size = 10,
}) => {
  // state object urlfile preview request
  const [urlFile, setUrlFile] = useState("");

  // state file
  const [file, setFile] = useState(null);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length != 0) {
        setUrlFile(
          acceptedFiles[0] ? URL.createObjectURL(acceptedFiles[0]) : ""
        );
        setFile(acceptedFiles[0]);
        onNewFile(acceptedFiles[0]);
      } else {
        Alertas({
          title: "",
          html: "<span>No se ha cargado el archivo debido a que este supera el tamaño maximo establecido.</span>",
          icono: "error",
        });
      }
    },
    multiple: false,
    accept: extensiones,
    minSize: 0,
    maxSize: size * 1000000,
  });

  const renderFile = () => {
    let htmlRenderFile = (
      <img
        src={urlFile ? urlFile : rutaEdit}
        alt={urlFile ? urlFile : rutaEdit}
        onLoad={() => {
          URL.revokeObjectURL(urlFile ? urlFile : rutaEdit);
        }}
      />
    );

    if (tipoFile.includes("Imagen")) {
      htmlRenderFile = (
        <img
          src={urlFile ? urlFile : rutaEdit}
          alt={urlFile ? urlFile : rutaEdit}
          onLoad={() => {
            URL.revokeObjectURL(urlFile ? urlFile : rutaEdit);
          }}
        />
      );
    }
    if (tipoFile.includes("Video")) {
      htmlRenderFile = (
        <video
          src={urlFile ? urlFile : rutaEdit}
          autoPlay
          controls
          loop
          muted
          onLoad={() => {
            URL.revokeObjectURL(urlFile ? urlFile : rutaEdit);
          }}
        />
      );
    }
    if (tipoFile.includes("Archivo")) {
      htmlRenderFile = (
        <img
          src={
            file?.name
              ? `${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Iconos/${file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                )}.jpg`
              : rutaEdit
          }
          alt={
            file?.name
              ? `${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Iconos/${file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                )}.jpg`
              : rutaEdit
          }
          onLoad={() => {
            URL.revokeObjectURL(
              file?.name
                ? `${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Iconos/${file?.name.substring(
                    file?.name.lastIndexOf(".") + 1,
                    file?.name.length
                  )}.jpg`
                : rutaEdit
            );
          }}
        />
      );
    }
    return htmlRenderFile;
  };
  return (
    <>
      <div className="container-file-upload">
        <div className="file-upload-label">
          <Form.Label className="label-forms-admin me-2" title="Activo">
            {tipoFile}
          </Form.Label>
        </div>
        <Dropzone {...getRootProps()}>
          <input {...getInputProps()} />
          {rutaEdit || urlFile ? (
            renderFile()
          ) : (
            <div className="container-picture">
              {config?.icon}
              <span className="description-picture">{config?.message}</span>
              <span className="description-picture">{`Tamaño límite ${size} MB`}</span>
            </div>
          )}
        </Dropzone>
      </div>
    </>
  );
};
